export default "__VITE_ASSET__D9DFj5w___"